import { Dict } from "./Dict";

// unknownにすると型推論が効かないケースがあるためanyにする
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UnknownProps = Dict<any>;
